<template>
  <div class="famousScholar">
    <Breadcrumb />
    <el-main>
      <EventDesc />
      <el-row class="nofull event_content">
        <EventMenu :menuActiveId="menuActiveId" />
        <el-main>
          <div class="contentEmpty" v-if="this.lengthNumber === 0">
            暂无内容
          </div>
          <RowCell
            v-for="item in cellList"
            :key="item.id"
            :avatar="item.avatar"
            :memberName="item.name"
            :memberOrg="item.organization"
            :proTitle="item.pro_title"
            :information="item.information"
          />
        </el-main>
      </el-row>
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb.vue';
import EventDesc from '@/components/EventDesc.vue';
import EventMenu from '@/components/EventMenu.vue';
import RowCell from '@/components/RowCell.vue';
import { getFamous } from '@/apis/famous.js';
export default {
  name: 'FamousScholar',
  components: {
    Breadcrumb,
    EventDesc,
    EventMenu,
    RowCell,
  },
  mounted() {
    this.$emit('activeIndex', '2');
    this.$emit('pageClass', 'event');
    let forum_id = this.$route.query.eventId;
    getFamous(forum_id)
      .then((res) => {
        if (res.status === 200) {
          if (res.data.success === true) {
            console.log(res.data);
            this.cellList = res.data.data.items.sort(
              (a, b) => a.sort_order - b.sort_order,
            );
            this.lengthNumber = this.cellList.length;
          } else {
            this.$message({
              showClose: true,
              message: res.data.message,
              type: 'success',
            });
          }
        } else {
          this.$message.error('未请求成功');
        }
      })
      .catch((error) => {
        console.log(error);
      });
  },
  data() {
    return {
      menuActiveId: '4',
      lengthNumber: null,
      cellList: [
        /*{
                        avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        memberName: '张东健',
                        pro_title: '教授',
                        memberOrg: '清华大学工商管理学院',
                        memberArea: '中国大陆',
                        entrySubEvent: '中国互联网经济发展20年',
                    },
                    {
                        avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        memberName: '张东健',
                        pro_title: '教授',
                        memberOrg: '清华大学工商管理学院',
                        memberArea: '中国大陆',
                        entrySubEvent: '中国互联网经济发展20年',
                    },
                    {
                        avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        memberName: '张东健',
                        pro_title: '教授',
                        memberOrg: '清华大学工商管理学院',
                        memberArea: '中国大陆',
                        entrySubEvent: '中国互联网经济发展20年',
                    },
                    {
                        avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        memberName: '张东健',
                        pro_title: '教授',
                        memberOrg: '清华大学工商管理学院',
                        memberArea: '中国大陆',
                        entrySubEvent: '中国互联网经济发展20年',
                    },
                    {
                        avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        memberName: '张东健',
                        pro_title: '教授',
                        memberOrg: '清华大学工商管理学院',
                        memberArea: '中国大陆',
                        entrySubEvent: '中国互联网经济发展20年',
                    },
                    {
                        avatar: 'https://fuss10.elemecdn.com/e/5d/4a731a90594a4af544c0c25941171jpeg.jpeg',
                        memberName: '张东健',
                        pro_title: '教授',
                        memberOrg: '清华大学工商管理学院',
                        memberArea: '中国大陆',
                        entrySubEvent: '中国互联网经济发展20年',
                    },*/
      ],
    };
  },
  watch: {
    '$store.state.toGetCurrentEvent.currentEvent'(v) {
      document.title = '知名学者 - ' + v.name ;
    },
  },
};
</script>

<style scoped></style>
